import { Box, IconButton, SwipeableDrawer } from '@pogokid/mui'
import React, { FC, useEffect } from 'react'
import { useIsMdBreakpoint } from '~m/AppUi/hooks/mediaQueries'
import { useActionsDrawer } from '~m/AppUi/context'
import MenuIcon from '@mui/icons-material/MenuOpen'
import styles from './ActionsDrawer.module.css'

interface ActionsDrawerProps {
  width?: number
}

export const ActionsDrawIcon = MenuIcon

export const ActionsDrawer: FC<
  React.PropsWithChildren<ActionsDrawerProps>
> = ({ width = 240, children }) => {
  const isMd = useIsMdBreakpoint()
  const { isOpen, setActionsDrawerOpen } = useActionsDrawer()
  useEffect(() => {
    setActionsDrawerOpen(isMd)
  }, [isMd, setActionsDrawerOpen])
  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          inset: '.2rem 0 auto auto',
          zIndex: 'drawer',
        }}
      >
        <IconButton
          size="large"
          onClick={() => setActionsDrawerOpen(!isOpen)}
        >
          <ActionsDrawIcon />
        </IconButton>
      </Box>
      <SwipeableDrawer
        className={styles.ActionsDrawer}
        anchor={'right'}
        variant={isMd ? 'persistent' : 'temporary'}
        open={isOpen}
        onOpen={() => setActionsDrawerOpen(true)}
        onClose={() => setActionsDrawerOpen(false)}
        sx={{
          width: width,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: width,
            boxSizing: 'border-box',
          },
        }}
      >
        {children}
      </SwipeableDrawer>
    </>
  )
}
